const s = require("./monitoring.module.scss");
import * as React from "react";

import TDate from "components/TDate";
import { MonitoringDto } from "core/backend/common";
import CheckIcon from "components/checkIcon";

interface OwnProps {
    dto: MonitoringDto;
    left: number;
}
const Row = ({ dto, left }: OwnProps) =>
    <tr className="small">
        <TDate rowSpan={1} date={new Date(dto.businessDayUtc)} left={left} />
        <td className="alignLeft">{dto.page}</td>
        <td className={dto.status === "Pending" ? s.pending :
            dto.status === "Received" ? s.received :
                dto.status === "Expected" ? s.expected : s.spanning}>{dto.status}</td>
        <td><CheckIcon checked={dto.followUpActionInitiated} /></td>
    </tr>

export default Row;